"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  loudspeaker: {
    remindText: 'Erinnere mich später',
    dismissText: 'Verstanden',
    viewAllAnnouncementsText: 'Klicken Sie hier, um alle Ankündigungen anzuzeigen',
    readMoreAllAnnouncementsLink: 'Weiterlesen'
  }
};
exports.default = _default;